import React from 'react';
import { Box as ChakraBox, BoxProps } from '@chakra-ui/react';
import { Text } from '../../../../components/UI-CHAKRA/Text';
import { FONT_ONEST, SNCR_COLORS } from '../constants';

type ItemAlertVariant = 'warning' | 'danger';

const VARIANT_STYLES: Record<ItemAlertVariant, { bg: string; color: string }> = {
  warning: { bg: SNCR_COLORS.warningBg, color: SNCR_COLORS.warningText },
  danger: { bg: SNCR_COLORS.dangerBg, color: SNCR_COLORS.dangerText },
};

interface ItemAlertBannerProps extends BoxProps {
  variant: ItemAlertVariant;
  children: React.ReactNode;
}

export const ItemAlertBanner = React.forwardRef<HTMLDivElement, ItemAlertBannerProps>(
  ({ variant, children, ...boxProps }, ref) => {
    const { bg, color } = VARIANT_STYLES[variant];

    return (
      <ChakraBox ref={ref} bg={bg} borderRadius="6px" padding="6px 12px" {...boxProps}>
        <Text fontSize="12px" fontWeight={600} fontFamily={FONT_ONEST} color={color}>
          {children}
        </Text>
      </ChakraBox>
    );
  }
);

ItemAlertBanner.displayName = 'ItemAlertBanner';
